/* eslint-disable no-unsafe-optional-chaining */
import React, { useState, useEffect, useContext, useRef } from 'react';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import { Container, Box, Grid, Button, Skeleton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTheme } from '@mui/material/styles';
import { useApolloClient } from '@apollo/client';
import styles from './styles';
import EirInformation from '../eir-information/EirInformation';
import CrossSellPreCard from './CrossSellPreCard';
import CrossSellLoader from './CrossSellLoader';
import { getTvTariffs, addTvTariffs, removeTvTariffs } from '../eir-tv/Tv.util';
import { useToggle } from '../../hooks/useToggle';
import { syncAPIandStrapiData, formatCrossSellStrapiData } from './CrossSell.util';
import useLocalStorage from '../../hooks/useLocalStorage';
import EirActionModal from '../eir-action-modal/EirActionModal';
import ErrorModal from '../eir-error-modal/ErrorModal';
import CrossSellSubscriptionSelectionModal from './CrossSellSubscriptionSelectionModal';
import fetchInfo from '../../../util/fetchModalData';
import { displayCart } from '../eir-cart/cart.util';
import RootContext from '../../../util/root.context';
import { getCookie, setCookie } from '../../hooks/useCookie';
import ApiFailureModal from '../eir-error-modal/ApiFailureModal';
import LoginMain403 from '../eir-403-login/LoginMain403';
import SessionExpireModal from '../eir-session-expire-modal/sessionExpireModal';

const { publicRuntimeConfig } = getConfig();
const CrossSellPreContainer = ({
  data,
  modalCmsData,
  tvSelected = false,
  hideTV = false,
  hideMobile = false,
  setShowNext,
  createCSForECC,
  // myEirTvAdd = false,
  // setMyEirTvAdd,
  // COEligibilityStatus,
  subscriptions,
  clearJourneyDetailsOnSubscriptionChange,
  openDialog,
  hideCS,
}) => {
  const theme = useTheme();
  const router = useRouter();
  const graphql = useApolloClient();
  const [cards, setCards] = useState([]);
  const [finalCards, setFinalCards] = useState([]);
  const [showCards, setShowCards] = useState(false);
  // const [loading, setLoading] = useState(true);
  const [TVtariff, setTVTariff] = useState([]);
  const [select, setSelect] = useState(false);
  const [onLoadError, setOnLoadError] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [openSubscriptionSelectionModal, setOpenSubscriptionSelectionModal] = useState(false);
  const { state: rootState, dispatch } = useContext(RootContext);
  const localStore = useLocalStorage();
  const [errorModalOccurence, setErrorModalOccurence] = useState(0);
  const [showLoader, setShowLoader] = useState(false);
  const errorModalMaxOccurence = 2;
  const errorBBModal = useToggle(false);
  const openAPIFailureModal = useToggle(false);
  const addMobileCSModal = useToggle(false);
  const preCardRef = useRef(null);
  const showModal = useToggle(false);
  const showSessionExpiredModal = useToggle(false);

  // getting tv tariff from api
  const getTvTariff = async () => {
    const tariff = await getTvTariffs({ graphql, contractDuration: '12', isCO: false, isCS: true });
    if (tariff?.length > 0) setTVTariff(tariff[0]);
  };
  // update cards with api data for tv
  const updateCards = (dataArray, tvTariff) => {
    if (
      dataArray.length > 0 &&
      Object.keys(tvTariff).length !== 0 &&
      tvTariff.constructor === Object
    ) {
      const tempData = syncAPIandStrapiData(dataArray, tvTariff);
      setCards(tempData);
    }
  };
  const handleOk = () => {
    openAPIFailureModal.disable();
  };

  const [cmsCollectionData, setCmsCollectionData] = useState({});
  const [load, setLoad] = useState(true);

  const getCmsData = async () => {
    try {
      const infoData = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: 'mw-eir-action-add-eirMobile',
      });
      if (Object?.keys(infoData).length !== 0) {
        setLoad(false);
        setCmsCollectionData(infoData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCmsData();
  }, []);

  useEffect(() => {
    const localRepoItems = getCookie('found-403');
    if (localRepoItems === 'true') {
      showModal.enable();
    } else {
      showModal.disable();
    }
    const expiredRepoItems = getCookie('token-missing');
    if (expiredRepoItems === 'true') {
      showSessionExpiredModal.enable();
    } else {
      showSessionExpiredModal.disable();
    }
  });

  const selectTariff = async (code, offerCode, cartType = 'CROSS_SELL') => {
    // if (COEligibilityStatus === 'ECC') await createCSForECC();
    if (getCookie('COMP_MAP')) {
      const COMP_MAP = JSON.parse(getCookie('COMP_MAP'));
      COMP_MAP.CO = false;
      setCookie('ION', 'COMP_MAP', JSON.stringify(COMP_MAP));
    }
    await createCSForECC();
    setShowLoader(true);
    setSelect(false);
    setShowNext(false);
    try {
      const response = await addTvTariffs(graphql, code, offerCode, rootState.cart, cartType);
      if (response != null && !response.error) {
        // addToCartAnalytics(data);
        dispatch({ type: 'SET_CART', payload: response });
        dispatch({ type: 'ENABLE_FOOTER', payload: false });
        displayCart({
          dispatch,
          localStorage: localStore,
          graphql,
          cart: response,
          disablenNextButton: false,
          showNextButton: false,
        });
        setSelect(true);
        setShowLoader(false);
        setErrorModalOccurence(0);
        errorBBModal.disable();
        setOnLoadError(false);
        if (!hideMobile) addMobileCSModal.enable();
        else router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/redirectSummary`);
      } else {
        setSelect(false);
        setOnLoadError(false);
        if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
        if (!getCookie('token-missing') && !getCookie('found-403'))
          setErrorModalOccurence(errorModalOccurence + 1);
        if (!getCookie('token-missing') && !getCookie('found-403')) errorBBModal.enable();
        setCookie('ION', 'API_FAILED', 'addTvTariffs');
        if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
        setShowLoader(false);
      }
    } catch (err) {
      setSelect(false);
      setOnLoadError(false);
      if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
      if (!getCookie('token-missing') && !getCookie('found-403'))
        setErrorModalOccurence(errorModalOccurence + 1);
      if (!getCookie('token-missing') && !getCookie('found-403')) errorBBModal.enable();
      setCookie('ION', 'API_FAILED', 'addTvTariffs');
      if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
      setShowLoader(false);
    }
  };
  const removeTariff = async () => {
    setShowLoader(true);
    setShowNext(false);
    try {
      if (rootState.cart?.offers.length > 0) {
        const offerId = await rootState.cart?.offers?.filter(
          offer => offer?.baseOffer?.serviceGroup === 'TV'
        )[0]?.id;
        if (offerId) {
          const response = await removeTvTariffs(graphql, offerId, 'CROSS_SELL');
          if (response != null && !response.error) {
            // removeFromCartAnalytics(data);
            dispatch({ type: 'SET_CART', payload: response });
            displayCart({
              showCart: false,
              dispatch,
              localStorage: localStore,
              graphql,
              cart: response,
              disablenNextButton: false,
              showNextButton: false,
            });
            setSelect(false);
            setShowLoader(false);
            setErrorModalOccurence(0);
            errorBBModal.disable();
            setOnLoadError(false);
          } else {
            setSelect(true);
            setOnLoadError(false);
            if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
            if (!getCookie('token-missing') && !getCookie('found-403'))
              setErrorModalOccurence(errorModalOccurence + 1);
            if (!getCookie('token-missing') && !getCookie('found-403')) errorBBModal.enable();
            setCookie('ION', 'API_FAILED', 'removeTvTariffs');
            if (!getCookie('token-missing') && !getCookie('found-403'))
              openAPIFailureModal.enable();
            setShowLoader(false);
          }
        }
      }
    } catch (err) {
      setSelect(true);
      setOnLoadError(false);
      if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
      if (!getCookie('token-missing') && !getCookie('found-403'))
        setErrorModalOccurence(errorModalOccurence + 1);
      if (!getCookie('token-missing') && !getCookie('found-403')) errorBBModal.enable();
      setCookie('ION', 'API_FAILED', 'removeTvTariffs');
      if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
      setShowLoader(false);
    }
  };
  const selectTariffFromModal = async () => {
    if (getCookie('COMP_MAP')) {
      const COMP_MAP = JSON.parse(getCookie('COMP_MAP'));
      COMP_MAP.CO = false;
      setCookie('ION', 'COMP_MAP', JSON.stringify(COMP_MAP));
    }
    const code = getCookie('CODE');
    const offerCode = getCookie('OFFER_CODE');
    await selectTariff(code, offerCode);
  };
  useEffect(() => {
    if (
      Object.keys(TVtariff).length !== 0 &&
      TVtariff.constructor === Object &&
      cards?.length > 0
    ) {
      updateCards(cards, TVtariff);
    }
  }, [TVtariff]);
  useEffect(() => {
    getTvTariff();
    const cardData = data.CSPreCard;
    const dataArray = formatCrossSellStrapiData(cardData);
    setCards(dataArray);
  }, []);
  useEffect(() => {
    if (hideCS === false) {
      if (hideTV && cards.length > 1) setFinalCards(cards?.filter(item => item.ctaType === 'nav'));
      if (hideMobile && cards.length > 1)
        setFinalCards(cards?.filter(item => item.ctaType === 'add'));

      if (!hideTV && !hideMobile) {
        setFinalCards(cards);
      }
    }
  }, [cards, hideTV, hideMobile, hideCS]);

  useEffect(() => {
    if (tvSelected) {
      // addMobileCSModal.enable();
      setShowNext(false);
    } else addMobileCSModal.disable();
    setShowNext(false);
  }, [tvSelected]);
  useEffect(() => {
    if (hideCS === true) setShowCards(false);
  }, [hideCS]);

  useEffect(() => {
    if (finalCards?.length > 0) {
      setShowCards(true);
    }
  }, [finalCards]);

  return (
    <Container
      sx={{
        p: 0,
        mb: 2,
        display: { sm: 'flex', md: 'flex' },
        flexDirection: { sm: 'column', md: 'column' },
        alignItems: { sm: 'center', md: 'center' },
        justifyContent: { sm: 'center', md: 'center' },
      }}
      maxWidth='lg'
      ref={preCardRef}
    >
      {showCards ? (
        <Box>
          <EirInformation
            title={data?.CSPreTitleDesc?.title}
            description={data?.CSPreTitleDesc?.description}
            style={{
              title: styles(theme).title,
              discription: { color: theme.palette.primary.textColor3 },
            }}
          />
        </Box>
      ) : (
        <Box>
          <Skeleton
            variant='rectangular'
            height={24}
            width={478}
            sx={{ ml: 'auto', mr: 'auto', mt: '1rem' }}
          />
          <Skeleton
            variant='rectangular'
            height={14}
            width={262}
            sx={{ ml: 'auto', mr: 'auto', mt: '1rem' }}
          />
        </Box>
      )}
      {showCards === false ? (
        <Grid
          container
          xs={12}
          spacing={2}
          sx={{ justifyContent: 'center', mt: '1rem', gap: '2rem', ml: 'auto', mr: 'auto' }}
        >
          <CrossSellLoader disableTitle />
        </Grid>
      ) : (
        <Grid
          container
          xs={12}
          sx={{ justifyContent: 'center', mt: '1rem', gap: '2rem', ml: 0 }}
          spacing={2}
        >
          {finalCards?.length > 0 &&
            showCards &&
            finalCards?.map(info => (
              <CrossSellPreCard
                card={info}
                tvSelected={tvSelected}
                modalCmsData={modalCmsData}
                selectTariff={selectTariff}
                removeTariff={removeTariff}
                showLoader={showLoader}
                // offerSelected={offerSelected}
                selected={select}
                setSelected={setSelect}
                createCSForECC={createCSForECC}
                subscriptions={subscriptions}
                setOpenSubscriptionSelectionModal={setOpenSubscriptionSelectionModal}
                openDialog={openDialog}
              />
            ))}

          {(tvSelected || getCookie('CART_TYPE') === 'CROSS_SELL') && (
            <Grid item xs={11} sx={{ paddingLeft: '0px !important' }}>
              <Box sx={styles(theme).checkOffersButtonContainer}>
                <Button
                  disableRipple
                  variant='buttonMedium'
                  sx={styles(theme).checkOffersButton}
                  startIcon={<ArrowBackIcon sx={{ fontSize: '1.3rem !important' }} />}
                  onClick={() => {
                    setCookie('CO', 'SUBSCRIPTION_ID', 0);
                    clearJourneyDetailsOnSubscriptionChange();
                  }}
                  aria-label='See Broadband again'
                >
                  See Broadband again
                </Button>
              </Box>
            </Grid>
          )}
        </Grid>
      )}

      {openError && errorModalOccurence > errorModalMaxOccurence && (
        <ApiFailureModal openAPIFailureModal={openAPIFailureModal} handleOk={handleOk} />
      )}
      {showModal.value && <LoginMain403 />}
      {showSessionExpiredModal !== undefined && showSessionExpiredModal.value && (
        <SessionExpireModal confirmLogOut={showSessionExpiredModal} />
      )}
      {errorBBModal.value && !showModal.value && !showSessionExpiredModal.value && (
        <ErrorModal
          errorBBModal={errorBBModal}
          occurences={errorModalMaxOccurence}
          currentOccurence={errorModalOccurence}
          ctaMethod={onLoadError ? () => {} : () => {}}
          // cmsDataImg={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsDataImages?.attributes?.EirImages_Broadband?.EirImages[2]?.Logo?.data?.attributes?.url}`}
          // cmsDataImgAlt={
          //   cmsDataImages?.attributes?.EirImages_Broadband?.EirImages[2]?.Logo?.data?.attributes
          //     ?.alternativeText
          // }
        />
      )}
      <EirActionModal
        id={cmsCollectionData?.attributes?.modalID}
        open={addMobileCSModal.value}
        handleClose={addMobileCSModal.disable}
        desktopImageSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI_SERVER}${
          cmsCollectionData?.attributes?.desktopImage?.data?.attributes?.url || ''
        }`}
        mobileImageSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI_SERVER}${
          cmsCollectionData?.attributes?.mobileImage?.data?.attributes?.url || ''
        }`}
        desktopImageAlt={
          cmsCollectionData?.attributes?.desktopImage?.data?.attributes?.alternativeText
        }
        mobileImageAlt={
          cmsCollectionData?.attributes?.mobileImage?.data?.attributes?.alternativeText
        }
        desktopCurveImg={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsCollectionData?.attributes?.desktopCurveImg?.data?.attributes?.url}`}
        mobileCurverImg={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsCollectionData?.attributes?.mobileCurverImg?.data?.attributes?.url}`}
        title={cmsCollectionData?.attributes?.title}
        description={`${
          cmsCollectionData?.attributes?.firstHalfDescription
            ? cmsCollectionData?.attributes?.firstHalfDescription
            : ''
        }
        ${
          cmsCollectionData?.attributes?.secondHalfDescription
            ? cmsCollectionData?.attributes?.secondHalfDescription
            : ''
        }
        `}
        cta={[
          {
            // text: 'Yes',
            text: cmsCollectionData?.attributes?.cta[0]?.name
              ? cmsCollectionData?.attributes?.cta[0]?.name
              : 'Yes',
            ariaLabel: cmsCollectionData?.attributes?.cta[0]?.ariaLabel
              ? cmsCollectionData?.attributes?.cta[0]?.ariaLabel
              : '',
            type: 'solid',
            action: () => {
              router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile`);
            },
          },
          {
            // text: 'Go to checkout',
            text: cmsCollectionData?.attributes?.cta[1]?.name
              ? cmsCollectionData?.attributes?.cta[1]?.name
              : 'Go to checkout',
            ariaLabel: cmsCollectionData?.attributes?.cta[1]?.ariaLabel
              ? cmsCollectionData?.attributes?.cta[1]?.ariaLabel
              : '',
            type: 'contained',
            action: () => {
              router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/redirectSummary`);
            },
          },
        ]}
        disableCloseOnBackdropClick
        disableCloseOnEscapeKeyDown
        disablecta={false}
        load={load}
      />
      {subscriptions?.length > 1 && openSubscriptionSelectionModal && (
        <CrossSellSubscriptionSelectionModal
          subscriptions={subscriptions}
          // cmsData={modalCmsData}
          func={selectTariffFromModal}
          setOpenSubscriptionSelectionModal={setOpenSubscriptionSelectionModal}
        />
      )}
    </Container>
  );
};

export default CrossSellPreContainer;
